import {createAsyncThunk} from '@reduxjs/toolkit';
import {accountApi} from "./account.api";
import {triggerEventAsync} from "../marketing/marketing.thunks";

export const setCultureAsync = createAsyncThunk(
    'account/setCultureAsync',
    async (arg, {dispatch, rejectWithValue}) => {
        try {
            const res = await dispatch(accountApi.endpoints.updateAccountCulture.initiate());
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getAccountAsync = createAsyncThunk('account/getAccount', async (arg, {dispatch, rejectWithValue}) => {
    try {
        const res = await dispatch(accountApi.endpoints.getAccount.initiate(arg));
        return res;
    } catch (error) {
        return rejectWithValue(error.message);
    }

});

export const loginAsync = createAsyncThunk(
    'account/loginAsync',
    async (userData, {dispatch, rejectWithValue}) => {
        try {
            const res = await dispatch(accountApi.endpoints.login.initiate(userData));
            let userRes = null;
            if (res.data.access_token) {
                userRes = await dispatch(accountApi.endpoints.getAccount.initiate(userData));
                dispatch(triggerEventAsync({eventName: 'login'}));
            }
            return userRes;
        } catch (error) {
            return console.error("Error", error.message);
        }
    }
);

export const loginWithPrivyAsync = createAsyncThunk(
    'account/loginWithPrivyAsync',
    async (privyData, {dispatch, rejectWithValue}) => {
        try {
            const res = await dispatch(accountApi.endpoints.loginWithPrivy.initiate(privyData));
            let userRes = null;
            if (res.data?.access_token) {
                userRes = await dispatch(accountApi.endpoints.getAccount.initiate());
                dispatch(triggerEventAsync({eventName: 'login'}));
            }
            return userRes;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const registerAsync = createAsyncThunk('account/registerAsync', async (userData, {dispatch, rejectWithValue}) => {
        try {
            const res = await dispatch(accountApi.endpoints.register.initiate(userData));

            if(res.data.access_token) {
                await dispatch(accountApi.endpoints.getAccount.initiate(userData));
                dispatch(triggerEventAsync({eventName: 'registration'}));
            }

            return res;
        } catch (error) {
            return console.error("Error", error.message);
        }
    }
)

export const updateAccountAsync = createAsyncThunk('account/updateAccountAsync', async (updatedUser, {
    dispatch,
    rejectWithValue
}) => {
    try {
        const res = await dispatch(accountApi.endpoints.updateAccount.initiate(updatedUser));
        return res;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const updateAddressAsync = createAsyncThunk('account/updateAddressAsync', async (address, {
    dispatch,
    rejectWithValue
}) => {
    try {
        const res = await dispatch(accountApi.endpoints.updateAddress.initiate(address));
        return res;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const saveAccountDetailsAsync = createAsyncThunk('account/saveAccountDetailsAsync', async (accountDetails, {
    dispatch,
    rejectWithValue
}) => {
    try {
        const res = await dispatch(accountApi.endpoints.updateAccountDetails.initiate(accountDetails));
        return res;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const getTransactionsAsync = createAsyncThunk('account/getTransactionsAsync', async (arg, {
    dispatch,
    rejectWithValue
}) => {
    try {
        const res = await dispatch(accountApi.endpoints.getTransactions.initiate(arg));
        return res;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const uploadPictureAsync = createAsyncThunk('account/uploadPictureAsync', async (picture, {
    dispatch,
    rejectWithValue
}) => {
    try {
        const res = await dispatch(accountApi.endpoints.uploadPicture.initiate(picture));
        return res;
    } catch (error) {
        return rejectWithValue("Error", error.message);
    }
});

export const sendContactUsAsync = createAsyncThunk('account/sendContactUsAsync', async (contactUsData, {
    dispatch,
    rejectWithValue
}) => {
    try {
        const res = await dispatch(accountApi.endpoints.sendContactUs.initiate(contactUsData));
        return res;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const withdrawFundsAsync = createAsyncThunk('account/withdrawFundsAsync', async (arg, {
    dispatch,
    rejectWithValue
}) => {
    try {
        const res = await dispatch(accountApi.endpoints.withdrawFunds.initiate(arg));
        return res;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});
